<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
      :model="info"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="标题" prop="title">
        <el-input
          v-model="info.title"
          maxlength="30"
          show-word-limit
          style="width:33%"
        ></el-input>
      </el-form-item>
      <el-form-item label="简介" prop="intro">
        <el-input
          v-model="info.intro"
          maxlength="120"
          show-word-limit
          style="width:66%"
        ></el-input>
      </el-form-item>
      <el-form-item label="图片">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="uploadOSSRequest"
          :before-upload="beforeImageUpload"
        >
          <img v-if="info.img_url" :src="info.img_url" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb，尺寸750x560 px
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="时间">
        <el-date-picker
          v-model="info.begin_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择开始时间"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="info.end_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择结束时间"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="地址" prop="address">
        <el-input v-model="info.address" style="width:50%"></el-input>
      </el-form-item>

      <el-form-item label="详情">
        <tinymce v-model="info.detail" style="width:66%"></tinymce>
      </el-form-item>

      <el-form-item label="客服微信号">
        <el-input v-model="info.counselor_wechat" style="width:33%"></el-input>
      </el-form-item>

      <el-form-item label="客服二维码">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="imageUploadOSSRequest3"
          accept="image/*"
        >
          <img v-if="info.counselor_wechat_img" :src="info.counselor_wechat_img" class="avatar2" />
          <i v-else class="el-icon-plus avatar-uploader-icon2"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb，尺寸 240x170
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="虚拟人数">
        <el-input type="number" v-model="info.virtual_order_number" style="width:33%"></el-input>
      </el-form-item>

      <el-form-item label="状态">
        <el-radio-group v-model="info.status">
          <el-radio :label="1">发布</el-radio>
          <el-radio :label="0">下架</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="短信模板">
        <el-input v-model="info.sms_template" style="width:33%"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="createUpdate()"
          :loading="updateLoading"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import tinymce from "@/components/tinymce.vue";

import {
  imageUploadOSSRequest,
  beforeImageUpload,
  uploadOSSRequest,
  getAliyunOssToken,
} from "@/api/common";

import { createUpdate, getDetail } from "@/api/lodging";

export default {
  data: function () {
    return {
      isshow: false,
      ossAction: "",
      ossData: {},
      loading: false,
      aliyunOssToken: "",
      updateLoading: false,
      categoryList: [],
      editor: null,
      info: {
        id: 0,
        title: "",
        intro: "",
        img_url: "",
        status: 0,
        virtual_order_number: 0,
        detail: "",
        begin_at: "",
        end_at: "",
        address: "",
        counselor_wechat: "",
        counselor_wechat_img: "",
        sms_template: ''
      },
    };
  },
  components: {
    tinymce,
  },
  created: function () {
    this.info.id = this.$route.query.id;
    if (this.info.id > 0) {
      this.getInfo();
    }
  },
  mounted() {},
  methods: {
    beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    imageUploadOSSRequest3(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        imageUploadOSSRequest(file.file, res.data, 500).then((fileUrl) => {
          this.info.counselor_wechat_img = fileUrl;
        });
      });
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.info.img_url = fileUrl;
        });
      });
    },

    getInfo() {
      this.loading = true;
      getDetail({
        id: this.info.id,
      }).then((response) => {
        this.info = response.data;
        this.loading = false;
      });
    },
    createUpdate() {
      this.updateLoading = true;
      createUpdate(this.info)
        .then((response) => {
          this.updateLoading = false;
          if (response.code == 1) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/lodging/list",
            });
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    ref() {
      window.history.go(-1);
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}

.avatar-uploader-icon2 {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar2 {
  width: 100px;
  height: 100px;
  display: block;
}
</style>